import XAPPService from 'app/Core/services/XAPPService';
import _ from 'lodash';

export const GET_EMPRESADEPOSITOS = '{EMPRESADEPOSITO APP] GET DEPOSITOS';
export const GET_EMPRESADEPOSITO = '{EMPRESADEPOSITO APP] GET DEPOSITO';
export const GET_TEMPLATE = '{EMPRESADEPOSITO APP] GET TEMPLATE';

export const OPEN_NEW_EMPRESADEPOSITO_DIALOG = '{EMPRESADEPOSITO APP] OPEN NEW DEPOSITO DIALOG';
export const CLOSE_NEW_EMPRESADEPOSITO_DIALOG = '{EMPRESADEPOSITO APP] CLOSE NEW DEPOSITO DIALOG';
export const OPEN_EDIT_EMPRESADEPOSITO_DIALOG = '{EMPRESADEPOSITO APP] OPEN EDIT DEPOSITO DIALOG';
export const CLOSE_EDIT_EMPRESADEPOSITO_DIALOG = '{EMPRESADEPOSITO APP] CLOSE EDIT DEPOSITO DIALOG';

export const EMPRESADEPOSITO_REMOVE = '{EMPRESADEPOSITO APP] DEPOSITO REMOVE';
export const ADD_EMPRESADEPOSITO = '{EMPRESADEPOSITO APP] ADD DEPOSITO';

export const EMPRESADEPOSITO_WARNING = '{EMPRESADEPOSITO APP] DEPOSITO WARNING';
export const EMPRESADEPOSITO_INFO = '{EMPRESADEPOSITO APP] DEPOSITO INFO';
export const EMPRESADEPOSITO_ERROR = '{EMPRESADEPOSITO APP] DEPOSITO ERROR';
export const EMPRESADEPOSITO_SELECIONAR_WARNING = '{EMPRESADEPOSITO APP] DEPOSITO SELECIONAR WARNING';
export const EMPRESADEPOSITO_SELECIONAR_INFO = '{EMPRESADEPOSITO APP] DEPOSITO SELECIONAR INFO';
export const EMPRESADEPOSITO_SELECIONAR_ERROR = '{EMPRESADEPOSITO APP] DEPOSITO SELECIONAR ERROR';


const ListState =
    [
        'idpessoaformulario',
        'idpessoa',
        'idparent',
        'nome',
        'tipo',
        'formulario',
        'statusregistro',
        'statusregistrodescricao',
        'usrins',
        'usrupt',
        'datainsdescricao',
        'datauptdescricao',
        'totalrows',
        'paginas',
    ];

const AddState =
    [
        'idparent',
        'formulario',
        'idpessoa',
        'tipo',
    ];

const UpdateState =
    [
        'formulario'
    ];

export function get(_AIDPessoaFormulario, _AParams) {

    return (dispatch) => {

        var AConditionsAND = [{ "Campo": "pessoaformulario.idpessoaformulario", "Operador": "=", "Valor": _AIDPessoaFormulario }];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "Depositos", AActions, "spvwempresadeposito", ListState, "SELECIONAR", AConditionsAND, AConditionsOR)

        XAPPService.XappSelAction(AActions, _AParams, "SEL")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_EMPRESADEPOSITO,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data[0] : "",
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESADEPOSITO_SELECIONAR_ERROR,
                    payload: error
                });
            });
    };
}

export function list(_AAction, _AParams, _AFilter = null, _APagina = 1, _ATarget = null, _ACallback = null) {

    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];
        var ATarget = !_.isNull(_ATarget) ? _ATarget : "spvwempresadeposito";

        if (_AFilter !== null) {
            if (_AFilter.AND !== undefined && _AFilter.AND !== null) {
                AConditionsAND = AConditionsAND.concat(_AFilter.AND);
            }

            if (_AFilter.OR !== undefined && _AFilter.OR !== null) {
                AConditionsOR = _AFilter.OR;
            }
        }

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "Depositos", AActions, ATarget, ListState, _AAction, AConditionsAND, AConditionsOR, _APagina)

        XAPPService.XappSelAction(AActions, _AParams, "SEL")
            .then((response) => {
                Promise.all([
                    dispatch({
                        type: GET_EMPRESADEPOSITOS,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                        pagina: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].pagina : 1,
                    })
                ]);
                if (!_.isNull(_ACallback)) {
                    _ACallback();
                }
            }
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESADEPOSITO_SELECIONAR_ERROR,
                    payload: error
                });
            });
    };
}

export function openNewDialog() {
    return {
        type: OPEN_NEW_EMPRESADEPOSITO_DIALOG
    }
}

export function closeNewDialog() {
    return {
        type: CLOSE_NEW_EMPRESADEPOSITO_DIALOG
    }
}

export function openEditDialog(data) {
    return {
        type: OPEN_EDIT_EMPRESADEPOSITO_DIALOG,
        data
    }
}

export function closeEditDialog() {
    return {
        type: CLOSE_EDIT_EMPRESADEPOSITO_DIALOG
    }
}

export function save(_AValue, _AParams, _ACallback = null) {
    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];
        var AAction = "INSERIR";

        if (_AValue.idpessoaformulario) {
            AAction = "ATUALIZAR";
            AConditionsAND = [{ "Campo": "idpessoaformulario", "Operador": "=", "Valor": _AValue.idpessoaformulario }];
            AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "pessoaformulario", AAction, _AValue, "idpessoaformulario", AConditionsAND, AConditionsOR, 1, UpdateState);

        }
        else {
            AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "pessoaformulario", AAction, _AValue, "idpessoaformulario", AConditionsAND, AConditionsOR, 1, AddState);
        }


        XAPPService.XappDoAction(AActions, _AParams, "DO")
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: EMPRESADEPOSITO_WARNING,
                            payload: response.warning
                        })
                    ]).then(() => {
                        if (!_.isNull(_ACallback)) {
                            _ACallback()
                        }
                    })
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: EMPRESADEPOSITO_INFO,
                            payload: response.info,
                            id: response.ultimoidinserido
                        })
                    ]).then(() => {
                        if (!_.isNull(_ACallback)) {
                            _ACallback()
                        }
                    })
                }
            }

            ).catch(error => {
                return dispatch({
                    type: EMPRESADEPOSITO_ERROR,
                    payload: error
                });
            });
    };
}

export function getTemplate() {
    return (dispatch) => {

        XAPPService.XappGetTemplateAction('pessoa', "119")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_TEMPLATE,
                        payload: response,
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESADEPOSITO_SELECIONAR_ERROR,
                    payload: error
                });
            });;
    }
}

export function acaoRegistro(_AValue, _AParams, _AAction, _ACallback = null) {
    return (dispatch) => {

        var AConditionsAND = [{ "Campo": "idpessoaformulario", "Operador": "=", "Valor": _AValue.idpessoaformulario }];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "pessoaformulario", _AAction, "", "", AConditionsAND, AConditionsOR);

        XAPPService.XappDoAction(AActions, _AParams, "DO")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: EMPRESADEPOSITO_REMOVE
                    })
                ]).then(() => {
                    if (!_.isNull(_ACallback)) {
                        _ACallback()
                    }
                })
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESADEPOSITO_ERROR,
                    payload: error
                });
            });
    };
}

export function clearReducer() {
    return {
        type: GET_EMPRESADEPOSITOS,
        data: null,
        pagina: 1,
    }
}